import React from 'react';

interface StatCardProps {
  icon: string;
  label: string;
  value: number | string;
  bgColor?: string;
  iconBg?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  bgColor = 'bg-white',
  iconBg = 'bg-[#EEF3F7]',
}) => {
  return (
    <div
      className={`${bgColor} border border-[#E5E9EB] rounded-3xl p-6 flex items-center gap-4 hover:shadow-md transition-shadow`}
    >
      <div
        className={`${iconBg} w-[56px] h-[56px] rounded-2xl flex items-center justify-center`}
      >
        <img src={icon} alt={label} className="w-[28px] h-[28px]" />
      </div>
      <div>
        <p className="text-[#9B919D] text-xs font-normal mb-1">{label}</p>
        <p className="text-[#292828] text-2xl font-semibold">{value}</p>
      </div>
    </div>
  );
};

interface UserStatsCardsProps {
  totalUsers: number;
  totalLinks: number;
  whitelistedUsers: number;
  totalClicks: number;
  loading?: boolean;
}

const UserStatsCards: React.FC<UserStatsCardsProps> = ({
  totalUsers,
  totalLinks,
  whitelistedUsers,
  totalClicks,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white border border-[#E5E9EB] rounded-3xl p-6 h-[104px] animate-pulse"
          >
            <div className="flex items-center gap-4">
              <div className="bg-gray-200 w-[56px] h-[56px] rounded-2xl" />
              <div className="flex-1">
                <div className="bg-gray-200 h-3 w-16 rounded mb-2" />
                <div className="bg-gray-200 h-6 w-20 rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <StatCard
        icon="/assets/users.svg"
        label="Total Users"
        value={totalUsers.toLocaleString()}
        iconBg="bg-[#EEF3F7]"
      />
      <StatCard
        icon="/assets/linkIcon.svg"
        label="Total Links"
        value={totalLinks.toLocaleString()}
        iconBg="bg-[#EEF3F7]"
      />
      <StatCard
        icon="/assets/whiteCheck.svg"
        label="Whitelisted"
        value={whitelistedUsers.toLocaleString()}
        iconBg="bg-[#EEF3F7]"
      />
      <StatCard
        icon="/assets/analyticsIcon.svg"
        label="Total Clicks"
        value={totalClicks.toLocaleString()}
        iconBg="bg-[#EEF3F7]"
      />
    </div>
  );
};

export default UserStatsCards;
